/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_Ability_ChoicesInputs */

const en_control_ability_choices = /** @type {(inputs: Control_Ability_ChoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ability choices`)
};

const zh_control_ability_choices = /** @type {(inputs: Control_Ability_ChoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`能力选择`)
};

/**
* | output |
* | --- |
* | "Ability choices" |
*
* @param {Control_Ability_ChoicesInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_ability_choices = /** @type {((inputs?: Control_Ability_ChoicesInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_Ability_ChoicesInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_ability_choices(inputs)
	return zh_control_ability_choices(inputs)
});
export { control_ability_choices as "control.ability_choices" }